export const WalletStatusType = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  SUSPENDED: 'SUSPENDED',
};

export const walletStatusTypes = [
  WalletStatusType.ACTIVE,
  WalletStatusType.INACTIVE,
  WalletStatusType.SUSPENDED,
];
